import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const categoryModURL = "api/v1/products-app/category";

//obtaining the paginated data
export const getCategory = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${categoryModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllCategory = () => axiosInstance.get(`${categoryModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCategory = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${categoryModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createCategory = (body) => axiosInstance.post(`${categoryModURL}/create`, body);
//updating function
export const updateCategory = (id, body) => axiosInstance.patch(`${categoryModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${categoryModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder} &search=${search}`);

// checking the redundant data
export const checkRedundantDataCategoryName = (e, cancelToken) =>
  axiosInstance.get(`${categoryModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
